import React, { useEffect } from 'react';

// Hooks
import { useState, useContext } from 'react';
import useHttp from '../hooks/useHttp';

// Context
import FiltersContext from './FiltersContext';

// Services
import { getEnvironmentApiUrl } from '../services/General';

// INterfaces
import { ReturnProfileAttributes, ProfileAttributes } from '../interfaces/Profile';

const DEFAULT_PROFILE_ATRIBUTES = {
    tableHasTerminalPhase: false,
    tableHasSupportResource: false,
    tableHasSouthAttention: false,
    tableHasSilencePact: false,
    showPatientCharts: true,
    showPadesGeneralInfo: false,
    patientInfoPhase: false,
    patientInfoCV: true,
    hasSonarButton: true,
    hasPadesAlertCircle: false,
    filterZone: true,
    filterStudy: true,
    filterPhase: false,
    filterDischarge: true,
};

// GeneralContext. Stores general context.
const ProfileContext = React.createContext<{ profileAttributes: ProfileAttributes | null }
>({ profileAttributes: null });

export const ProfileContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    // handles whether the sidebar is displayed.
    const [profileAttributes, setProfileAttributes] = useState<ProfileAttributes | null>(null);

    const { patientFilters: { currentProfileID } } =
        useContext(FiltersContext);

    const { sendRequest } = useHttp<ReturnProfileAttributes>();

    useEffect(() => {
        if (currentProfileID !== null)
            sendRequest(
                { url: getEnvironmentApiUrl() + 'profile/attributes/' + currentProfileID },
                (data) => setProfileAttributes(data),
                () => setProfileAttributes(DEFAULT_PROFILE_ATRIBUTES)
            );
    }, [currentProfileID, sendRequest]);

    const initState = {
        profileAttributes,
    };

    return (
        <ProfileContext.Provider value={initState}>
            {children}
        </ProfileContext.Provider>
    );
};
export default ProfileContext;